// =============================================================================
// themes/index — rejestr motywow. Motyw = CSS(wariacja) + renderery per rodzaj
// strony. Faza 1: editorial. Faza 5: magazine / minimal / sidebar.
// =============================================================================

import type { BrandModel, CategoryModel, PageModel, ThemeId } from "../types";
import type { Variation } from "./variation";
import type { RenderCtx } from "./shared";
import { editorialTheme } from "./editorial";

export interface ThemeRenderers {
  home(ctx: RenderCtx): string;
  article(ctx: RenderCtx, page: PageModel): string;
  category(ctx: RenderCtx, category: CategoryModel, pages: PageModel[]): string;
  author(ctx: RenderCtx, page: PageModel): string;
  page(ctx: RenderCtx, page: PageModel): string;
  notFound(ctx: RenderCtx): string;
}

export interface Theme {
  id: ThemeId;
  label: string;
  description: string;
  css(v: Variation, brand: BrandModel | null): string;
  renderers: ThemeRenderers;
}

export const THEMES: Record<string, Theme> = {
  editorial: editorialTheme,
};

export const THEME_LIST: Theme[] = Object.values(THEMES);

export function getTheme(id: string | null | undefined): Theme {
  return THEMES[id || ""] || editorialTheme;
}

export type { RenderCtx } from "./shared";
